// extracted by mini-css-extract-plugin
export default {"p":"_788e58555d _3c3ec8876c cb90828bb0","clr":"_39e9d1c3cb","dls":"fcf1cc37a0"};